<template>
  <div class="finances">
    <div class="finances__header box">
      <div class="row no-gutters align-items-center">
        <div class="col-12 col-lg-8">
          <div class="box bg-white balance">
            <div class="row">

              <div class="col-12 col-md-6">
                <div class="balance-block">
                  <div class="tariff__id color-gray">{{ $t("contract") }} № {{ contract.numberContract }}</div>
                  <div class="balance__block">
                    <div class="balance-block__title section__title section__title_style3">
                      {{$t("balance")}}: <span :class="contract.obk >= 0 ? 'color-green' : 'color-red'"> {{ contract.obk ? formatOBK(contract.obk) : '0' }} {{$t("tenge")}}</span>
                    </div>
                    <div class="balance-block__title section__title section__title_style3">
                      {{$t("debtAmount")}}: <span :class="contract.debtAmount >= 0 ? 'color-green' : 'color-red'"> {{ contract.debtAmount ? formatOBK(contract.debtAmount) : '0' }} {{$t("tenge")}}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-4">
          <div class="box pay-online">
            <button class="btn btn_white btn_default btn_with-icon" @click="setContractInf(contract.idContract, contract.debtAmount)" type="button" data-target="#modal-pay-online"
                    data-toggle="modal"><span class="btn__icon svg-icon">
                    <svg role="img" width="24" height="24" aria-hidden="true">
                      <use xlink:href="#svg-icon-card"></use>
                    </svg></span><span class="btn__text">{{$t("topUpOnline")}}</span></button>
          </div>
        </div>
      </div>
    </div>
    <div class="row justify-content-between align-items-center">
      <div class="col-12 col-md-auto">
        <div class="finances__title section__title section__title_style3">{{$t("paymentHistory")}}</div>
      </div>
      <div class="col-12 col-md-auto">
        <div class="form-group form-group_date">
      <!-- <date-filter> -->
        <!-- <label class="form-label form-label_hidden" for="start-date-finances">Дата начала отчетного периода</label> -->
          <input class="form-control input__date input__date_start" :type="inputType" @focus="this.inputType='date'"
               v-model="dateStart" :placeholder='$t("from")' required>
        <!-- <label class="form-label form-label_hidden" for="end-date-finances">Дата окончания отчетного периода</label> -->
          <input class="form-control input__date" :type="inputType2" @focus="this.inputType2='date'"
               v-model="dateEnd" :placeholder='$t("to")' required>
      <!-- </date-filter> -->
        </div>
      </div>
    </div>
    <div class="finances__body box bg-white">
      <div class="table-responsive" v-show="paginatedData.length">
        <table class="table table_default">
          <thead class="thead">
          <tr class="tr">
            <th class="th">{{$t("paymentDate")}}</th>
            <th class="th">{{$t("sum")}}</th>
            <th class="th">{{$t("placeOfPayment")}}</th>
          </tr>
          </thead>
          <tbody class="tbody">
          <tr class="tr" v-for="payment in paginatedData" :key="payment.extId">
            <td class="td">{{ payment.payDt }}</td>
            <td class="td">{{ payment.pamount }} {{$t("tenge")}}</td>
            <td class="td td_nowrap">{{ payment.source }}</td>
          </tr>
          </tbody>
        </table>
      </div>
      <div v-show="!paginatedData.length">
        {{$t("paymentHistoryEmpty")}}
      </div>
    </div>
    <pagination :listData="filtredPayment" :pageNumber="pageNumber" :size="size" @changePage="change"></pagination>
    <div class="finances__footer">
      <a class="link" href="javascript: void(0);" download><span class="link__icon svg-icon" aria-hidden="true">
        <svg role="img" width="18" height="18" aria-hidden="true">
            <use xlink:href="#svg-icon-download"></use>
        </svg></span><span class="link__text" @click="download">{{$t("download")}}</span><span class="link__file">{{$t("fileName")}}</span>
      </a>
    </div>
  </div>
</template>
<script>
import DateFilter from "@/components/UI/DateFilter";
import Pagination from "@/components/UI/Pagination"
import {mapState, mapGetters, mapMutations, mapActions} from 'vuex'
export default {
  components: {
    DateFilter,
    Pagination
  },
  props: {
    contract: {
      type: Object,
      default: function () {
        return {
          idContract: '',
          numberContract: '',
          obk: '',
          payment: '',
          PaymentObject: [
            {
              extId: '',
              source: '',
              payDt: '',
              pamount: ''
            }
          ]
        }
      }
    }
  },
  data() {
    return {
      inputType: 'text',
      inputType2: 'text',
      dateStart: '',
      dateEnd: '',
      pageNumber: 1,
      size: 10
    }
  },
  methods: {
    ...mapActions({
      downloadFinance: 'finance/downloadFinance',
    }),
    formatDate(dateStr) {
      let separatorIdx = dateStr.indexOf(' ')
      const [dd, mm, yyyy] = dateStr.slice(0, separatorIdx).split('.')

      return new Date(`${yyyy}-${mm}-${dd}`)
    },
    download() {
      this.downloadFinance().then((res) => {
        const FILE = window.URL.createObjectURL(new Blob([res.data]));
        let docUrl = document.createElement('a');
        docUrl.href = FILE;
        docUrl.setAttribute('download', 'История платежей.pdf');
        document.body.appendChild(docUrl);
        docUrl.click();

      });
    },
    change(value){
      this.pageNumber = value;
    },
    setContractInf(num, debt){
      this.$emit('setContractData', num, debt);
    },
    isEmpty(obj) {
      for (let key in obj) {
        return false;
      }
      return true;
    },
    formatOBK(obk){
      return (+obk.toFixed(2)).toLocaleString('ru');
    }
  },
  computed: {
    filtredPayment() {
      const startDate = this.dateStart && new Date(this.dateStart)
      const endDate = this.dateEnd && new Date(this.dateEnd)

      return !this.isEmpty(this.$props.contract.PaymentObject) ? this.$props.contract.PaymentObject.filter(payment => {
        const payDt = this.formatDate(payment.payDt)
        if (startDate && endDate) {
          return startDate <= payDt && payDt <= endDate;
        }
        if (startDate && !endDate) {
          return startDate <= payDt;
        }
        if (!startDate && endDate) {
          return payDt <= endDate;
        }
        return true;
      }) : []
    },
    paginatedData(){
      const start = (this.pageNumber-1) * this.size,
            end = start + this.size;
      return this.filtredPayment.slice(start, end);
    }
  }
}
</script>
<style scoped>
.form-group_date{
  border: 1px solid #289853;
  border-radius: 8px;
  width: 362px;
}
.input__date{
  border: none;
  flex-shrink: 0;
  width: 180px;
  flex-grow: 0;
}
.input__date_start{
  border-right: 1px solid #289853;
  border-radius: 8px 0px 0px 8px;
}
.finances{
  margin-bottom: 30px;
}
.balance__block{
  display: flex;
  flex-wrap: wrap;
  column-gap: 30px;
}
.col-md-6{
  max-width: 100%;
  flex: 0 0 100%;
}
@media (max-width: 768px) {
  .form-group_date{
    width: 100%;
  }
  .input__date{
    width: 50%;
  }
}

</style>